import { SITE } from "./constants";
import type { FreeTestId } from "./freeTests";

export const EMBED_HEIGHT = 640;
export const RESIZE_MESSAGE = "helibrain:resize";

/** The full page path already includes its locale, if any. */
export const embedPath = (path: string) => `/embed${path}`;

export function isEmbedPage(): boolean {
  return typeof window !== "undefined" && window.location.pathname.startsWith("/embed/");
}

/** Attribution is a hostname only. Never retain the referring URL or query. */
export function embedAttribution(): { embed: true; embed_host: string | null } | Record<string, never> {
  if (!isEmbedPage()) return {};
  let host: string | null = null;
  try {
    const url = new URL(document.referrer);
    if (url.protocol === "https:" || url.protocol === "http:") host = url.hostname;
  } catch { /* A missing/blocked referrer is normal. */ }
  return { embed: true, embed_host: host };
}

const escapeHtml = (value: string) => value.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!);

export const embedAllow = (test: FreeTestId) => test === "musical_ear" ? "autoplay" : undefined;

export function embedCode(path: string, name: string, test: FreeTestId): string {
  const allow = embedAllow(test);
  return `<iframe src="${SITE.url}${embedPath(path)}" title="${escapeHtml(name)}" loading="lazy" width="100%" height="${EMBED_HEIGHT}" style="border:0;color-scheme:inherit"${allow ? ` allow="${allow}"` : ""}></iframe>\n<p><a href="${SITE.url}${path}" target="_blank" rel="noopener">${escapeHtml(name)}</a> by Helibrain</p>`;
}

/** Optional, dependency-free host script. Match both origin AND frame window;
 * untrusted messages can only request a finite, bounded height. No scores cross. */
export function embedResizeCode(): string {
  return `<script>\nwindow.addEventListener("message", function (event) {\n  if (event.origin !== "${SITE.url}") return;\n  var data = event.data;\n  if (!data || data.type !== "${RESIZE_MESSAGE}" || data.version !== 1 ||\n      typeof data.height !== "number" || !Number.isFinite(data.height) ||\n      data.height < 200 || data.height > 12000) return;\n  document.querySelectorAll('iframe[src^="${SITE.url}/embed/"]').forEach(function (frame) {\n    if (frame.contentWindow === event.source) frame.style.height = Math.ceil(data.height) + "px";\n  });\n});\n</script>`;
}
